import { combineReducers, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import thunk from 'redux-thunk';
import { FestivalOverviewAppState } from './../classes/redux-states';
import festivalOverviewApiReducer from './reducers/festival-reducer';
import festivalOverviewSettingsReducer from './reducers/settings-reducer';



let combined = combineReducers({
    festivalOverviewApiModel: festivalOverviewApiReducer,
    festivalOverviewSettingsModel: festivalOverviewSettingsReducer,
});

var festivalOverviewStore = createStore(combined, applyMiddleware(thunk)) as Store<any>;

var previousState = festivalOverviewStore.getState();

festivalOverviewStore.subscribe(() => {
    const currentState = festivalOverviewStore.getState();
    const apiModel = currentState as FestivalOverviewAppState;
    const prevApiModel = previousState as FestivalOverviewAppState;

    previousState = currentState;
});

export { festivalOverviewStore }